import { z } from "zod";

const gygUrlPattern = /^https?:\/\/(www\.)?getyourguide\.[a-z]+\//;
const viatorUrlPattern = /^https?:\/\/(www\.)?viator\.com\//;
const tripadvisorUrlPattern = /^https?:\/\/(www\.)?tripadvisor\.[a-z]+\//;

export const createTourSchema = z
  .object({
    name: z.string().min(1, "Name is required").max(200, "Name too long"),
    gygUrl: z
      .string()
      .url("Invalid URL")
      .regex(gygUrlPattern, "Invalid GetYourGuide URL")
      .optional()
      .or(z.literal("")),
    viatorUrl: z
      .string()
      .url("Invalid URL")
      .regex(viatorUrlPattern, "Invalid Viator URL")
      .optional()
      .or(z.literal("")),
    tripadvisorUrl: z
      .string()
      .url("Invalid URL")
      .regex(tripadvisorUrlPattern, "Invalid Tripadvisor URL")
      .optional()
      .or(z.literal("")),
  })
  .refine(
    (data) => data.gygUrl || data.viatorUrl || data.tripadvisorUrl,
    { message: "At least one platform URL is required" }
  );

export const updateTourSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  gygUrl: z
    .string()
    .url()
    .regex(gygUrlPattern, "Invalid GetYourGuide URL")
    .optional()
    .or(z.literal("")),
  viatorUrl: z
    .string()
    .url()
    .regex(viatorUrlPattern, "Invalid Viator URL")
    .optional()
    .or(z.literal("")),
  tripadvisorUrl: z
    .string()
    .url()
    .regex(tripadvisorUrlPattern, "Invalid Tripadvisor URL")
    .optional()
    .or(z.literal("")),
});

export type CreateTourSchema = z.infer<typeof createTourSchema>;
export type UpdateTourSchema = z.infer<typeof updateTourSchema>;
